import { Cartesian3 } from "cesium";
import { ArcSegment } from "../../geometric-elements/arc-segment";
import { CurveType } from "../../geometric-elements/interface";
import { BaseHorizontalAlignmentSegment } from "./horizontal-alignment-base-segment";
import { CurveDataType, } from "./interface";
export class HAThreePointArc extends BaseHorizontalAlignmentSegment {
    type = CurveDataType.THREE_POINT_ARC;
    startPoint;
    throughPoint;
    endPoint;
    element;
    constructor(startPoint, throughPoint, endPoint) {
        super();
        this.startPoint = startPoint;
        this.throughPoint = throughPoint;
        this.endPoint = endPoint;
        this.recomputeElement();
    }
    isStartPoint(pointId) {
        return this.startPoint.id === pointId;
    }
    isEndPoint(pointId) {
        return this.endPoint.id === pointId;
    }
    get data() {
        return {
            startPointId: this.startPoint.id,
            throughPointId: this.throughPoint.id,
            endPointId: this.endPoint.id,
            type: CurveDataType.THREE_POINT_ARC,
        };
    }
    get surveyPoints() {
        return [this.startPoint, this.throughPoint, this.endPoint];
    }
    dispose() {
        this.element?.dispose();
        this.startPoint = undefined;
        this.throughPoint = undefined;
        this.endPoint = undefined;
    }
    containsPointId(pointId) {
        return (this.startPoint.id === pointId ||
            this.endPoint.id === pointId ||
            this.throughPoint.id === pointId);
    }
    recomputeElement() {
        this.element?.dispose();
        this.element = ArcSegment.fromThreePointArcData({
            type: CurveType.ARC,
            start: new Cartesian3(this.startPoint.localPoint.x, this.startPoint.localPoint.y, 0),
            through: new Cartesian3(this.throughPoint.localPoint.x, this.throughPoint.localPoint.y, 0),
            end: new Cartesian3(this.endPoint.localPoint.x, this.endPoint.localPoint.y, 0),
        });
    }
}
//# sourceMappingURL=horizontal-alignment-three-point-arc.js.map